import { z } from 'zod';

import {
  type ContextChunkModel,
  contextChunkModelSchema,
  contextChunkModelToJson,
} from '@/domain/models/contextChunkModel';

/** Пакет источников, приходящий событием `context_chunks`. */
export interface ContextChunksDataModel {
  readonly chunks: readonly ContextChunkModel[];
}

/**
 * Переименований нет. `@Default([])` из Dart: отсутствующий или `null`
 * список даёт пустой — событие без источников не ломает разбор.
 */
export const contextChunksDataModelSchema = z.object({
  chunks: z
    .array(contextChunkModelSchema)
    .nullish()
    .transform((value): readonly ContextChunkModel[] => value ?? []),
});

export function contextChunksDataModelFromJson(
  json: unknown,
): ContextChunksDataModel {
  return contextChunksDataModelSchema.parse(json);
}

export function contextChunksDataModelToJson(
  model: ContextChunksDataModel,
): Record<string, unknown> {
  return {
    chunks: model.chunks.map(contextChunkModelToJson),
  };
}
